<template>
  <!-- Main Content -->
  <div class="page-wrapper">
    <div class="container-fluid">

      <!-- Title -->
      <div class="row heading-bg">
        <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12">
          <h5 class="txt-dark">
            <back-button link="/main/tickets"></back-button> 
            Follow-Ups of TICKET: {{ ticket.id }}
            <add-button :link="`/main/tickets/${ticket.id}/follow-ups/create`"></add-button>
          </h5>
        </div>
        <!-- Breadcrumb -->
        <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
          <ol class="breadcrumb">
            <li><router-link to="/">Dashboard</router-link></li>
            <li>Data Center</li>
            <li class="active">Follow-Ups</li>
            <!-- <li class="active">Follow-Ups of {{ ticket.name }}</li> -->
          </ol>
        </div>
        <!-- /Breadcrumb -->
      </div>
      <!-- /Title -->
      
      <!-- Row -->
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default card-view">
            <div class="panel-wrapper collapse in">
              <div class="panel-body">
                <div class="table-wrap">
                  <table class="table table-hover table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table :isLoading="isLoading" cols="2"></loading-table>
                      <router-link 
                        v-for="(followUp, at) in followUps"
                        :key="`followUp${at}`"
                        :to="`/main/tickets/${ticket.id}/follow-ups/${followUp.id}`"
                        tag="tr"
                      >
                        <td>{{ serialNoStarting + at + 1 }}</td>
                        <td>{{ followUp.description }}</td>
                      </router-link>
                    </tbody>
                  </table>
                </div>
                <pagination :count="count" @submit="getData"></pagination>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <!-- /Row -->
    </div>
  </div>
  <!-- /Main Content -->
</template>

<script type="text/javascript">
import axios from 'axios'

export default {
  name: 'followUps',
  data () {
    return {
      ticket: {},
      followUps: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    
    async getData(page = 1) {
      this.isLoading = true
      let ticket = await axios.get(`tickets/${this.$route.params.ticketId}`)
      this.ticket = ticket.data.data
      let followUps = await axios.get(`/tickets/${this.$route.params.ticketId}/ticket_followups?page=${page}&rowsPerPage=${this.rowsPerPage}`)
      this.followUps = followUps.data.data
      this.count = followUps.data.count
      this.serialNoStarting = (page - 1) * this.rowsPerPage
      this.isLoading = false
    }
  }
}
</script>